import React from 'react';

import {useInteractionStore} from '../../../store/slices/interactionStore';
import './DotTyping.style.scss';

export const DotTyping = () => {
  const dotTyping = useInteractionStore((state) => state.dotTyping);

  return (
    <>
      {dotTyping && (
        <div className="box-typing">
          <div className="snippet" data-title="dot-typing">
            <div className="stage">
              <div className="dot-typing" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
